import getValidColor from './get-valid-color';

type GetBgColor = {
  backgroundColor: string;
  hexColor: string;
};

export function getBgColor({ backgroundColor, hexColor }: GetBgColor) {
  const hasHexcolorDropdown = backgroundColor === 'HEXCOLOR';
  const hasBgHexcolor = hexColor !== '';
  const color =
    hasHexcolorDropdown && hasBgHexcolor
      ? hexColor
      : getValidColor(backgroundColor);
  return color;
}
